import {
  ConversationStatus,
  MeetingBookingStatus
} from 'generated-graphql/types';

export const acceptedStatuses = [
  ConversationStatus.CompletedMeetingRequested,
  ConversationStatus.CompletedAwaitingCall,
  ConversationStatus.CompletedCustomRequest
];

export const rejectedStatuses = [ConversationStatus.CompletedRejected];

export const completedStatuses = [
  ...acceptedStatuses,
  ...rejectedStatuses,
  ConversationStatus.Completed,
  ConversationStatus.CompletedNotInterested
];

export const bookedMeetingStatuses = [
  MeetingBookingStatus.Scheduled,
  MeetingBookingStatus.Rescheduled,
  MeetingBookingStatus.ReschedulingRequested
];
